import {
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  SecretApiKey,
  SecretApiKeyExpires,
} from "../utils/setting";

import jwt from "jsonwebtoken";
import { dispatch } from "@rematch/core";
import { Cookies } from "react-cookie";
import { checkResponse } from "../utils/checkResponse";
// import {serviceMenuItem} from './serviceMenuItem';
const cookie = new Cookies();
const serviceMenu = {
  state: {
    idMenuArray: [],
    listMultiLevel: [],
    listMenuGroup: [],
  },
  reducers: {
    setState(state, payload) {
      this.state = { ...state, ...payload };
      return { ...this.state };
    },
    changeIdMenuArray(state, payload) {
      state.idMenuArray = payload;
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async getMenuGroup(payload = {}, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let decode = await jwt.decode(token);
      if (decode) {
        let dataDecode = JSON.parse(decode.data);
        let data = {
          userCode: dataDecode.userCode,
          ...payload,
        };
        let url =
          DomainAPI + Channel + "/api/secure/serviceMenu/getListMenuService";

        let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
          expiresIn: SecretApiKeyExpires,
        });
        let myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append(APIKey, key);
        myHeaders.append(Authorization, rootState.user.token);

        return fetch(url, {
          method: "POST",
          headers: myHeaders,
          body: JSON.stringify(data),
        })
          .then((res) => res.json())
          .then((result) => {
            checkResponse(result, dispatch);
            if (result.code === 1)
              _this.setState({ listMultiLevel: result.data });
            return result;
          })
          .catch((error) => {
            return { code: 0, error: error, message: error.toString() };
          });
      }
    },
    async getAllMenuGroup(payload, rootState) {
      const _this = this;
      let token = rootState.user.token;
      let decode = await jwt.decode(token);
      let dataDecode = JSON.parse(decode.data);
      let serviceCode = rootState.service.adminService
        ? rootState.service.adminService.no
        : null;
      let data = {
        serviceCode: serviceCode,
        userCode: dataDecode.userCode,
      };
      let url = DomainAPI + Channel + "/api/secure/serviceMenu/getAll";

      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          if (result.code === 1) _this.setState({ listMenuGroup: result.data });
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async editMenuGroup(payload, rootState) {
      const _this = this;
      let serviceCode = rootState.service.adminService
        ? rootState.service.adminService.no
        : null;
      let url = DomainAPI + Channel + "/api/secure/serviceMenu/editMenuGroup";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          serviceCode: serviceCode,
          ...payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async addMenuGroup(payload, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/serviceMenu/addMenuGroup";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify({
          serviceCode: rootState.service.adminService
            ? rootState.service.adminService.no
            : null || null,
          data: payload,
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          // if (result.code === 1) _this.getMenuGroup();
          checkResponse(result, dispatch);
          dispatch.serviceSetting.getServiceSetting(); // Cập nhât lại list service setting
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
    async deleteMenuGroup(payload, rootState) {
      const _this = this;
      let serviceCode = rootState.service.adminService
        ? rootState.service.adminService.no
        : null;
      let data = {
        serviceCode: serviceCode,
        menuId: payload.menuId,
      };
      let url = DomainAPI + Channel + "/api/secure/serviceMenu/deleteMenuGroup";
      let key = await jwt.sign({ data: Math.random() }, SecretApiKey, {
        expiresIn: SecretApiKeyExpires,
      });
      let myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(APIKey, key);
      myHeaders.append(Authorization, rootState.user.token);

      return fetch(url, {
        method: "POST",
        headers: myHeaders,
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          checkResponse(result, dispatch);
          return result;
        })
        .catch((error) => {
          return { code: 0, error: error, message: error.toString() };
        });
    },
  }),
};

export default serviceMenu;
